<span [class]="{'bold': isBold && !isEntryMode, 'negative': isNegative && !isEntryMode, 'schwab-edit-icon-left': editIconOnHover && !isEntryMode}"><input type="text" pInputText
#inputField
[value]="displayValue"
(focus)="onFocus()"
(focusout)="onBlur()"
(keyup.enter)="blurInput()"
[formControl]="inputControl"
tooltip 
[tooltipTitle]="tooltipMessage" 
[tooltipPosition]="'right'" 
tooltipClass="error"
[tooltipHorizontalOffset]="8"
(input)="onInputChange()"
[placeholder]="placeholder"
[style.width]="width" 
[min]="min"
[max]="max"
[attr.disabled]="setDisabled()"
(keypress)="onKeyPress($event)"
(paste)="onPaste($event)"
autocomplete="off"
autocorrect="off" 
autocapitalize="off" 
spellcheck="false"></span>
